import { i18n } from '@js/i18n'

export default {
  form: {
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    residenceCountry: '',
    residenceCity: '',
    residenceAddress: '',
    residenceZipCode: ''
  },
  rows: [
    [
      {
        "heading": i18n.kyc_submit_personal_information()
      }
    ],
    [
      {
        "model": "firstName",
        "name": "first-name",
        "id":  "kyc-first-name",
        "label": i18n.lbl_first_name(),
        "field": "text",
        "required": true,
        "validate": "required|max:30"
      }
    ],
    [
      {
        "model": "lastName",
        "name": "last-name",
        "id":  "kyc-last-name",
        "label": i18n.lbl_last_name(),
        "field": "text",
        "required": true,
        "validate": "required|max:50"
      }
    ],
    [
      {
        "model": "dateOfBirth",
        "name": "date-of-birth",
        "label": i18n.lbl_date_of_birth(),
        "id":  "kyc-date-of-birth",
        "field": "date",
        "required": true,
        "validate": "required",
        "disableAfter": new Date().toString(),
        "disableBefore": "",
        "class": "field-calendar"
      }
    ],
    [
      {
        "subheading": i18n.kyc_submit_legal_address()
      }
    ],
    [
      {
        "model": "residenceCountry",
        "name": "residence-country",
        "id":  "kyc-country",
        "label": i18n.lbl_residence_country(),
        "field": "vue-select",
        "required": true,
        "values": "countries",
        "validate": "required"
      }
    ],
    [
      {
        "model": "residenceCity",
        "name": "residence-city",
        "id":  "kyc-city",
        "label": i18n.lbl_city(),
        "field": "text",
        "required": true,
        "validate": "required"
      }
    ]
  ]
}



// WEBPACK FOOTER //
// ./src/vue/app/verification/spec/general/step-1.general.schema.js